import type { ContactUsForm, ContactUsSuccessResponse } from '@libs/common-node';

import { cweaClient } from '../clients/api-proxy-browser-client';
import { CWEA_ENDPOINTS } from '../constants';

export async function handleContactUs(body: ContactUsForm) {
    try {
        const url = CWEA_ENDPOINTS.customerCare.contactUs;

        const response = await cweaClient.post<ContactUsSuccessResponse, ContactUsForm>(`${url}`, {
            body,
            useOldFetch: true,
        });

        // API response is null when unsuccessful, so we manually set isSuccess to false
        return response ?? { isSuccess: false };
    } catch {
        return {
            isSuccess: false,
        };
    }
}
